/* eslint-disable */
import { List, ListSubheader } from '@material-ui/core';
import * as React from 'react';

import { CheckFilter } from './check-filter';
import { CurrencyField } from './currency-field';

export function Filters({
  currencyCode,
  productTypes,
  tags,
  vendors,
  filters,
  setFilters,
}) {
  const updateFilter = (key, value) => {
    setFilters((filters) => ({ ...filters, [key]: value }));
  };

  const updateNumeric = (key, value) => {
    if (
      !isNaN(Number(value)) ||
      (value.endsWith('.') && !isNaN(Number(value.substring(0, -1))))
    ) {
      updateFilter(key, value);
    }
  };

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader id="nested-list-subheader" component="div">
          Filtros
        </ListSubheader>
      }
    >
      <CheckFilter
        name="Type"
        items={productTypes}
        selectedItems={filters.productTypes}
        setSelectedItems={(value) => updateFilter('productTypes', value)}
      />
      <CheckFilter
        name="Brands"
        items={vendors}
        selectedItems={filters.vendors}
        setSelectedItems={(value) => updateFilter('vendors', value)}
      />
      <CheckFilter
        name="Tags"
        items={tags}
        selectedItems={filters.tags}
        setSelectedItems={(value) => updateFilter('tags', value)}
      />

      <details open={true}>
        <summary>
          <div>
            Price
            {(filters.maxPrice || filters.minPrice) && (
              <button
                onClick={() =>
                  setFilters((filters) => ({
                    ...filters,
                    maxPrice: '',
                    minPrice: '',
                  }))
                }
              >
                Reset
              </button>
            )}
          </div>
        </summary>
        <div>
          <CurrencyField
            {...currencyCode}
            aria-label="Minimum price"
            value={filters.minPrice}
            onChange={(event) =>
              updateNumeric('minPrice', event.currentTarget.value)
            }
          />
          &nbsp;–&nbsp;
          <CurrencyField
            {...currencyCode}
            aria-label="Maximum price"
            value={filters.maxPrice}
            onChange={(event) =>
              updateNumeric('maxPrice', event.currentTarget.value)
            }
          />
        </div>
      </details>
    </List>
  );
}
